if (!customElements.get('collapsible-description')) {
  customElements.define(
    'collapsible-description',
    class CollapsibleDescription extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.product__description-content');
        this.button = this.querySelector('.product__description-toggle');
        this.textMore = this.button.querySelector('.toggle-text-more');
        this.textLess = this.button.querySelector('.toggle-text-less');
        this.iconHorizontal = this.button.querySelector('.toggle-icon-horizontal');

        this.isExpanded = false;
        this.maxHeight = 300; // Hauteur max avant collapse (en pixels)

        this.init();
      }

      init() {
        // Vérifier si le contenu dépasse la hauteur max
        if (this.content.scrollHeight <= this.maxHeight) {
          // Le contenu est court, cacher le bouton
          this.button.style.display = 'none';
          return;
        }

        // Le contenu est long, activer le collapse
        this.content.style.maxHeight = this.maxHeight + 'px';
        this.content.classList.add('collapsed');

        // Ajouter l'event listener
        this.button.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        this.isExpanded = !this.isExpanded;

        if (this.isExpanded) {
          // Expand
          this.content.style.maxHeight = this.content.scrollHeight + 'px';
          this.content.classList.remove('collapsed');
          this.textMore.classList.add('hidden');
          this.textLess.classList.remove('hidden');
          this.iconHorizontal.style.opacity = '0';
        } else {
          // Collapse
          this.content.style.maxHeight = this.maxHeight + 'px';
          this.content.classList.add('collapsed');
          this.textMore.classList.remove('hidden');
          this.textLess.classList.add('hidden');
          this.iconHorizontal.style.opacity = '1';

          // Scroll vers le haut de la description
          this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  );
}
